import { Injectable, NgZone } from "@angular/core";
import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { MatDialog } from '@angular/material/dialog';

const SINGLE_NFT721_JSON = require("src/app/Contracts/Rinkeby/NFT.json");
const MULTIPLE_NFT1155_JSON = require("src/app/Contracts/Rinkeby/MultNFT.json");
const ERC_20_JSON = require("src/app/Contracts/Rinkeby/ERC20.json");
const MARKET_PLACE_JSON = require("src/app/Contracts/Rinkeby/MarketPlace.json");
const LAZY_MINT_JSON = require("src/app/Contracts/Rinkeby/LazyMint.json");
const BATCH_MINT_JSON = require("src/app/Contracts/Rinkeby/Batchmint.json");
const BATCH_MINT_MARKETPLACE_JSON = require("src/app/Contracts/Rinkeby/BatchMarketPlace.json");
const MARKET_PLACE_1155_JSON = require("src/app/Contracts/Rinkeby/MarketPlace_1155.json");
const ERC_20_Kombat_JSON = require('src/app/Contracts/Rinkeby/ERC20_Kombat.json');
const GFL_KP_Exchange_JSON = require('src/app/Contracts/Rinkeby/GflKpExchange.json');

import { environment } from "src/environments/environment";
import { API as AWS_API } from "aws-amplify";
import { ToastrService } from "ngx-toastr";
import { Polygon, rinkebyJSON } from "../BlockChainInfo";
import { StorageService } from "./storage.service";

@Injectable({
  providedIn: "root",
})
export class Web3Service {
  changedAccount: any;
  changedAccountSubject = new Subject<any>();
  private accountId = new BehaviorSubject("");
  connectedAccId = this.accountId.asObservable();
  Contracts_Rinkeby: any;
  private web3js: any;
  private provider: any;
  private accounts: any;
  web3Modal: any;
  balance: string | undefined;
  messageResult: string;
  walletcon: boolean = false;
  marketplace: any;
  network_name: any;
  erc721contract: any;
  erc1155contract: any;
  marketplacecontract: any;
  erc20contract: any;
  marketplacecontract_1155: any;
  lazymintcontract: any;
  batchmintcontract: any;
  batchmintmarketplacecontract: any;
  gflkp_exchangecontract: any;
  erc20_Kombatcontract: any;
  isPhantom = environment.clientDetails.network === "solana";

  constructor(private ngZone: NgZone, private dialog: MatDialog, private toastr: ToastrService, private storageService: StorageService) {
    const providerOptions = {
      walletconnect: {
        package: WalletConnectProvider, // required | here whe import the package necessary to support wallets|| aqui importamos el paquete que nos ayudara a usar soportar distintas wallets
        options: {
          qrcode: false,
          infuraId: "env", // required change this with your own infura id | cambia esto con tu apikey de infura
          description: "Scan the qr code and sign in", // You can change the desciption | Puedes camnbiar los textos descriptivos en la seccion description
          qrcodeModalOptions: {
            mobileLinks: [
              "rainbow",
              "metamask",
              "argent",
              "trust",
              "imtoken",
              "pillar",
            ],
          },
        },
      },
      injected: {
        display: {
          logo: environment.clientDetails.network === "solana"
            ? "https://187760183-files.gitbook.io/~/files/v0/b/gitbook-x-prod.appspot.com/o/spaces%2F-MVOiF6Zqit57q_hxJYp%2Fuploads%2FHEjleywo9QOnfYebBPCZ%2FPhantom_SVG_Icon.svg?alt=media&token=71b80a0a-def7-4f98-ae70-5e0843fdaaec"
            : "https://upload.wikimedia.org/wikipedia/commons/3/36/MetaMask_Fox.svg",
          name: environment.clientDetails.network === "solana" ? "Phantom" : "Metamask",
          description: "Connect with the provider in your Browser",
        },
        package: null,
      },
    };

    this.web3Modal = new Web3Modal({
      network: "mainnet", // optional
      cacheProvider: true, // optional
      providerOptions, // required
      theme: {
        background: "rgb(39, 49, 56)",
        main: "rgb(199, 199, 199)",
        secondary: "rgb(136, 136, 136)",
        border: "rgba(195, 195, 195, 0.14)",
        hover: "rgb(16, 26, 32)",
      },
    });
    if ((window as any).ethereum) {
      (window as any).ethereum.on("accountsChanged", (accounts) => {
        this.ngZone.run(() => {
          this.accountId.next(accounts[0]);
          this.sendchangedaccount(accounts[0]);
        });
      });

      (window as any).ethereum.on("chainChanged", (network) => {
      console.log("chainChanged",network);
        this.ngZone.run(() => {
          this.getchainId().then(() => {
            this.sendchangedaccount();
          });
        });
        let chainId = network === "0x13882" ? "Polygon" : "Sepolia";
        let changedNetwork = network === "0x13882" ? "poly" : "sep";
        localStorage.setItem("networkId", chainId);
        this.changeNetwork(changedNetwork)
        this.setContract();
      });

    }
  }

  changeContract() {
    this.Contracts_Rinkeby = localStorage.getItem('networkId') == 'Polygon' ? Polygon : rinkebyJSON;
  }

  signout() {
    this.web3Modal.clearCachedProvider();
    this.storageService.clear();
  }


  chainID: any = "Network";
  getchainId() {
    return new Promise(async(resolve) => {
      this.provider = await this.web3Modal.connect(); 
      this.web3js = new Web3(this.provider);
      this.web3js.eth.getChainId().then((data) => {
        this.provider && (data = this.provider.chainId);
        console.log("provider network", data);
        if (!data || data != null || data != undefined) {
          this.chainID = data;
          if (
            Number(this.chainID) == environment.clientDetails.polychain ||
            Number(this.chainID) == Number(environment.clientDetails.polyhex) || Number(this.chainID) === 80002
          ) {
            this.chainID = "Polygon";
            localStorage.setItem("networkId", this.chainID);
            this.setContract();

          } else if (
            Number(this.chainID) == environment.clientDetails.avaxchain ||
            Number(this.chainID) == Number(environment.clientDetails.avahex) || Number(this.chainID) === 11155111
          ) {
            this.chainID = "Sepolia";
            localStorage.setItem("networkId", this.chainID);
            this.setContract();
          } else {
            this.chainID = "Polygon";
            localStorage.setItem("networkId", this.chainID);
            this.setContract();
          }
        }
        localStorage.setItem("networkId", this.chainID);
        this.Contracts_Rinkeby = localStorage.getItem('networkId') == 'Polygon' ? Polygon : rinkebyJSON;
        this.setContract();
        resolve(this.chainID);
      });
    });
  }
  // changeAbi() {
  //   this.Contracts_Rinkeby =
  //     localStorage.getItem("networkId") == "Polygon"
  //       ? Polygon
  //       : localStorage.getItem("networkId") == "Avalanche"
  //       ? Ava
  //       : Polygon;
  // }

  // intermidateConnect() {
  //   console.log("intermidateConnect");
  //   return new Promise(async (resolve) => {
  //     this.provider = await this.web3Modal.connect(); //JSON.parse(localStorage.getItem('Set_Provider'));
  //     // debugger
  //     if (this.provider) {
  //       this.web3js = new Web3(this.provider);
  //     } // create web3 instance
  //     else{
  //       // alert('undefined web3')
  //     }
  //     const accounts = await this.web3js.eth.getAccounts();
  //     this.accounts = accounts[0];
  //     let balance = await this.accountInfo(this.accounts);
  //     this.mapWallet(this.accounts, (data) => {
  //       if (data == 1) {
  //         this.setContract();
  //         this.updateAccountAddress(this.accounts);
  //         resolve(this.accounts);
  //         return this.accounts;
  //       } else {
  //         this.toastr.error("Your wallet has been blocked");
  //         localStorage.setItem("WalletId", "");
  //         resolve(undefined);
  //         return undefined;
  //       }
  //     });
  //   });
  // }

  async intermidateConnect() {
    console.log("intemediate connect")
    return new Promise(async (resolve, reject) => {
      try {
        if ("phantom" in window) {
          console.log("phantom")
          const provider = (window as any).phantom?.solana;
          if (provider?.isPhantom) {
            // await this.web3Modal.clearCachedProvider();
            this.provider = await this.web3Modal.connect();
            const response = await provider.connect();
            const walletAddress = response.publicKey.toString();
            localStorage.setItem('WalletId', walletAddress);
            this.provider = provider; // Set the provider
            this.web3js = new Web3(this.provider);
            this.accounts = walletAddress;
            this.setContract();
            this.updateAccountAddress(this.accounts);
            let balance = await this.accountInfo(this.accounts);
            this.mapWallet(this.accounts, (data) => {
              if (data == 1) {
                this.setContract();
                this.updateAccountAddress(this.accounts);
                resolve(this.accounts);
                return this.accounts;
              } else {
                this.toastr.error("Your wallet has been blocked");
                localStorage.setItem("WalletId", "");
                resolve(undefined);
                return undefined;
              }
            });
            resolve(this.accounts);
          }
        } else if ((window as any).ethereum) {
          console.log("metamask wallet");
          // await this.web3Modal.clearCachedProvider();
          // console.log("this.web3Modal",this.web3Modal, this.provider);
          this.provider = await this.web3Modal.connect();
          console.log(">>>",this.provider);
          this.web3js = new Web3(this.provider);
          const accounts = await this.web3js.eth.getAccounts();
          this.accounts = accounts[0];
          this.setContract();
          this.updateAccountAddress(this.accounts);
          let balance = await this.accountInfo(this.accounts);
          this.mapWallet(this.accounts, (data) => {
            if (data == 1) {
              this.setContract();
              this.updateAccountAddress(this.accounts);
              resolve(this.accounts);
              return this.accounts;
            } else {
              this.toastr.error("Your wallet has been blocked");
              localStorage.setItem("WalletId", "");
              resolve(undefined);
              return undefined;
            }
          });
          resolve(this.accounts);
        } else {
          reject("No wallet detected. Please install Phantom or MetaMask.");
        }
      } catch (error) {
        console.error("Failed to connect:", error);
        reject("Failed to connect to wallet.");
      }
    });
  }

  async sendchangedaccount(data?) {
    this.changedAccount = data;
    if (this.provider) {
      this.web3js = new Web3(this.provider);
    } // create web3 instance
    const accounts = await this.web3js.eth.getAccounts();
    this.accounts = accounts[0];
    this.mapWallet(this.accounts, (data) => {
      if (data == 1) {
        localStorage.setItem("WalletId", accounts[0]);
        this.changedAccountSubject.next(this.accounts);
      } else {
        localStorage.setItem("WalletId", "");
        // alert("Your wallet has been blocked")
        this.toastr.error("Your wallet has been blocked");
      }
    });
  }

  getchangeaccount(): Observable<any> {
    return this.changedAccountSubject.asObservable();
  }
  nftstep: any;
  nftstepsubject = new Subject<any>();
  sendnftstep(data) {
    this.nftstep = data;
    this.nftstepsubject.next(data);
  }
  getnftstep(): Observable<any> {
    return this.nftstepsubject.asObservable();
  }
  // connectAccount() {
  //   console.log("connectAccount");
  //   return new Promise(async (resolve) => {
  //     console.log("connectAccount 2");
  //     this.web3Modal.clearCachedProvider();
  //     this.provider = await this.web3Modal.connect(); // set provider
  //     console.log("Provider ", this.provider);
  //     console.log(
  //       "Wallet connected to blockchain network Id: ",
  //       this.provider.networkVersion
  //     );
  //     // if (this.provider.networkVersion !== "4") {
  //     //   //alert("Please select Rinkeby Test Network")
  //     //   return ""
  //     // }
  //     if (this.provider) {
  //       this.web3js = new Web3(this.provider);
  //     } // create web3 instance
  //     const accounts = await this.web3js.eth.getAccounts();
  //     this.accounts = accounts[0];
  //     this.setContract();
  //     if (this.accounts) {
  //       this.mapWallet(this.accounts, (data) => {
  //         if (data == 1) {
  //           localStorage.setItem("WalletId", accounts[0]);
  //           this.updateAccountAddress(this.accounts);
  //           this.sendchangedaccount(this.accounts);
  //           resolve(this.accounts);
  //           return this.accounts;
  //         } else {
  //           localStorage.setItem("WalletId", "");
  //           // alert("Your wallet has been blocked")
  //           this.toastr.error("Your wallet has been blocked");
  //           resolve(undefined);
  //           return undefined;
  //         }
  //       });
  //       let balance = await this.accountInfo(this.accounts);
  //     }
  //     // return undefined;
  //   });
  // }

  connectAccount(): Promise<string> {
    console.log("connectAccount");
    return new Promise(async (resolve, reject) => {
      if ("phantom" in window) {
        const provider = (window as any).phantom?.solana;
        if (provider?.isPhantom) {
          // await this.web3Modal.clearCachedProvider();
          this.provider = await this.web3Modal.connect();
          provider.connect()
            .then((response) => {
              const walletAddress = response.publicKey.toString();
              this.accounts = walletAddress;
              localStorage.setItem('WalletId', walletAddress);
              this.setContract();
              if (this.accounts) {
                this.mapWallet(this.accounts, (data) => {
                  if (data == 1) {
                    this.updateAccountAddress(this.accounts);
                    this.sendchangedaccount(this.accounts);
                    resolve(this.accounts);
                    return this.accounts;
                  } else {
                    localStorage.setItem("WalletId", "");
                    // alert("Your wallet has been blocked")
                    this.toastr.error("Your wallet has been blocked");
                    resolve(undefined);
                    return undefined;
                  }
                });
              }
              resolve(walletAddress);
            })
            .catch((error) => {
              console.error("Failed to connect to Phantom wallet:", error);
              reject("Failed to connect to Phantom wallet.");
            });
        }
      } else if ((window as any).ethereum) {
        // await this.web3Modal.clearCachedProvider();
          this.provider = await this.web3Modal.connect();
        (window as any).ethereum.request({ method: "eth_requestAccounts" })
          .then((accounts) => {
            console.log("accounts", accounts);
            const walletAddress = accounts[0];
            this.accounts = walletAddress;
            this.setContract();
            if (this.accounts) {
              this.mapWallet(this.accounts, (data) => {
                if (data == 1) {
                  localStorage.setItem("WalletId", accounts[0]);
                  this.updateAccountAddress(this.accounts);
                  this.sendchangedaccount(this.accounts);
                  resolve(this.accounts);
                  return this.accounts;
                } else {
                  localStorage.setItem("WalletId", "");
                  // alert("Your wallet has been blocked")
                  this.toastr.error("Your wallet has been blocked");
                  resolve(undefined);
                  return undefined;
                }
              });
            }
            resolve(walletAddress);
          })
          .catch((error) => {
            console.error("Failed to connect to Ethereum wallet:", error);
            reject("Failed to connect to Ethereum wallet.");
          });
      } else {
        reject("No wallet detected. Please install Phantom or MetaMask.");
      }
    });
  }

  mapWallet(accountNumber, callback) {
    let url = "mapWallet";
    let payload = {
      wallet_id: accountNumber,
    };
    // let userInfo = JSON.parse(localStorage.userInfo);
    let userInfo = JSON.parse(localStorage.userInfo != undefined ? localStorage.userInfo : localStorage.user_Info);
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        Authorization: `Bearer ${userInfo.access_token}`,
      },
      response: true,
      body: payload,
    };
    AWS_API.post(environment.AWS_Cognito.apiName, url, myInit)
      .then((response) => {
        callback(response.data.data.status);
      })
      .catch((error) => {
        console.log(error, ">>>>>???????");
      });
  }

  importTokens = async (chainId, tokenSymbol, tokenAddress) => {
    const tokenDecimals = 18;
    try {
      let chain;
      this.getchainId().then((res) => {
        chain = res;
      });
      if (chainId !== chain) {
        console.log(`Switching to network: ${chainId}`);
        try {
          await window.ethereum.request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId }],
          });
          console.log("Switched network successfully!");
        } catch (switchError) {
          // If the chain is not available, add it
          if (switchError.code === 4902) {
            console.log("Network not found in MetaMask. Adding network...");
            try {
              await window.ethereum.request({
                method: "wallet_addEthereumChain",
                params: [{
                  chainId: chainId,
                  chainName: "Polygon Amoy Testnet",
                  nativeCurrency: {
                    name: "POL",
                    symbol: "POL",
                    decimals: 18,
                  },
                  rpcUrls: ["https://rpc-amoy.polygon.technology"],
                  blockExplorerUrls: ["https://amoy.polygonscan.com/"],
                }],
              });
              console.log("Network added successfully!");
            }
            catch (addError) {
              console.error("Failed to add network:", addError);
              if (addError.code !== -32603) {
                return;
              }
            }
          } else {
            console.error("Error switching network:", switchError);
            return;
          }
        }
      }
      localStorage.setItem("networkId", 'Polygon');
      this.setContract();
      console.log("localstorage networkId", localStorage.getItem('networkId'));
      this.Contracts_Rinkeby = localStorage.getItem('networkId') == 'Polygon' ? Polygon : rinkebyJSON;
      const wasAdded = await window.ethereum.request({
        method: "wallet_watchAsset",
        params: {
          type: "ERC20",
          options: {
            address: tokenAddress,
            symbol: tokenSymbol,
            decimals: tokenDecimals,
          },
        },
      });
      console.log("was added");
      tokenSymbol= tokenSymbol ==='GFL'?'GFL':environment.clientDetails.name ==='BigbeeAI' ? 'BB' :'KP';
      if (wasAdded) {
        this.toastr.success(`${tokenSymbol} tokens successfully added to MetaMask!`);
        console.log("Token successfully added to MetaMask!");
      } else {
        this.toastr.error(`Failed to add ${tokenSymbol} tokens to MetaMask.`);
        console.log("Token addition was rejected.");
      }
    } catch (error) {
      console.error("Error adding token:", error);
    }
  }


  public getNetwork() {
    return this.network_name;
  }

  public setNetwork(name) {
    this.network_name = name;
  }

  async accountInfo(account: any[]) {
    const initialvalue = await this.web3js.eth.getBalance(account);
    this.balance = this.web3js.utils.fromWei(initialvalue, "ether");
    return this.balance;
  }

  // public checkAndInstantiateWeb3(): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     if (window.ethereum) {
  //       // window.ethereum.on("accountsChanged", (accounts) => {
  //       //   this.accounts = accounts[0]
  //       //   this.updateAccountAddress(this.accounts)
  //       //   })
  //       this.messageResult = "connected";
  //       window.web3 = new Web3(window.ethereum);
  //       // window.ethereum.enable().
  //       // resolve(this.messageResult);
  //       try {
  //         const accounts = window.ethereum.request({
  //           method: "eth_requestAccounts",
  //         });
  //         this.messageResult = "connected";
  //         // this.accounts = accounts[0]
  //         // this.updateAccountAddress(this.accounts)
  //         resolve(this.messageResult);
  //         // setAccounts(accounts);
  //       } catch (error) {
  //         if (error.code === 4001) {
  //           //alert("connect to web3")
  //         }
  //         // setError(error);
  //       }
  //     } else if (window.web3) {
  //       this.messageResult = "connected";
  //       window.web3 = new Web3(window.web3.currentProvider);
  //       resolve(this.messageResult);
  //     } else {
  //       // //alert("No digital wallet detected. Install atleast Metamask")
  //       this.messageResult =
  //         "No Ethereum browser detected. you should consider trying MetaMask";
  //       reject(this.messageResult);
  //     }
  //   });
  // }

  public checkAndInstantiateWeb3(): Promise<string> {
    return new Promise((resolve, reject) => {
      if (environment.clientDetails.network === "solana" && ('phantom' in window || (window as any)?.isPhantomInstalled)) {
        const provider = (window as any).phantom?.solana;
        if (provider?.isPhantom) {
          this.messageResult = "connected";
          window.web3 = new Web3(provider);
          resolve(this.messageResult);
        }
        else {
          reject("phantom not installed");
        }
      } else if (window.ethereum && !(window as any).isPhantomInstalled && environment.clientDetails.network !== "solana") {
        this.messageResult = "connected";
        (window as any).web3 = new Web3((window as any).ethereum);
        try {
          const accounts = (window as any).ethereum.request({
            method: "eth_requestAccounts",
          });
          this.messageResult = "connected";
          resolve(this.messageResult);
        } catch (error) {
          if (error.code === 4001) {
            reject("error");
            // User rejected the request
          }
        }
      } else if ((window as any).web3 && environment.clientDetails.network !== "solana") {
        this.messageResult = "connected";
        (window as any).web3 = new Web3((window as any).web3.currentProvider);
        resolve(this.messageResult);
      } else {
        let wallet = "MetaMask";
        if (environment.clientDetails.network === "solana") {
          wallet = "Phantom"
        }
        this.messageResult =
          `No Ethereum or Phantom browser detected. You should consider installing ${wallet} wallet.`;
        reject(this.messageResult);
      }
    });
  }

  public loadBlockChainData(): Promise<string> {
    return new Promise((resolve, reject) => {
      const web3 = window.web3;
      const account = web3.eth.getAccounts();
      // const account = window.ethereum.request({ method: 'eth_requestAccounts' });
      if (this.accounts !== undefined) {
        resolve(this.accounts);
      } else {
        this.messageResult = "There is no account";
        reject(this.messageResult);
      }
    });
  }

  public getEtherBalance(account) {
    return new Promise((resolve) => {
      const web3 = window.web3;
      const balance = web3.eth.getBalance(account).then((ba) => {
        resolve(web3.utils.fromWei(ba, "Ether"));
      });
    });
  }
  public setContract() {
    // console.log(">>>>>>>>>>", this.provider.chainId);
    console.log(localStorage.getItem("networkId"));
    console.log(localStorage.getItem("networkId"), this.Contracts_Rinkeby);
    var abi, networkAddress;
    var contract_nw;
    console.log("this.getNetwork()", this.getNetwork());

    // if (this.getNetwork() == "Ethereum Rinkeby") {
    //   contract_nw = this.Contracts_Rinkeby;
    // }
    // if (this.getNetwork() == "Avalanche") {
    //   contract_nw = this.Contracts_Rinkeby;
    // }

    contract_nw = localStorage.getItem("networkId") === "Polygon" || localStorage.getItem("networkId") === "Network" ? Polygon : rinkebyJSON;
    this.Contracts_Rinkeby = contract_nw;
    console.log("contract_nw", contract_nw);
    // contract_nw = this.provider.chainId === environment.clientDetails.polyhex ? Polygon : rinkebyJSON;
    const web3 = new Web3(this.provider);

    abi = SINGLE_NFT721_JSON;
    networkAddress = contract_nw.SINGLE_NFT721_ADDRESS;
    this.erc721contract = new web3.eth.Contract(abi, networkAddress);

    abi = MULTIPLE_NFT1155_JSON;
    networkAddress = contract_nw.MULTIPLE_NFT1155_ADDRESS;
    this.erc1155contract = new web3.eth.Contract(abi, networkAddress);

    abi = MARKET_PLACE_JSON;
    networkAddress = contract_nw.MARKET_PLACE_ADDRESS;
    this.marketplacecontract = new web3.eth.Contract(abi, networkAddress);

    abi = ERC_20_JSON;
    networkAddress = contract_nw.ERC_20_ADDRESS;
    // console.log("abii",abi);
    this.erc20contract = new web3.eth.Contract(abi, networkAddress);
    // console.log("this.erc20contract",this.erc20contract);


    abi = MARKET_PLACE_1155_JSON;
    networkAddress = contract_nw.MARKET_PLACE_1155_ADDRESS;
    this.marketplacecontract_1155 = new web3.eth.Contract(abi, networkAddress);

    abi = LAZY_MINT_JSON;
    networkAddress = contract_nw.LAZY_MINT_ADDRESS;
    this.lazymintcontract = new web3.eth.Contract(abi, networkAddress);

    abi = BATCH_MINT_JSON;
    networkAddress = contract_nw.BATCH_MINT_ADDRESS;
    this.batchmintcontract = new web3.eth.Contract(abi, networkAddress);

    abi = BATCH_MINT_MARKETPLACE_JSON;
    networkAddress = contract_nw.BATCH_MINT_MARKETPLACE_ADDRESS;
    this.batchmintmarketplacecontract = new web3.eth.Contract(
      abi,
      networkAddress
    );

    abi = ERC_20_Kombat_JSON;
    networkAddress = contract_nw.ERC_20_ADDRESS_Kombat;
    this.erc20_Kombatcontract = new web3.eth.Contract(abi, networkAddress);

    abi = GFL_KP_Exchange_JSON;
    networkAddress = contract_nw.GFL_KP_EXCHANGE_ADDRESS;
    this.gflkp_exchangecontract = new web3.eth.Contract(abi, networkAddress);

    console.log("set contract end line");
  }

  changeNetwork(data) {
    // let chaninID =
    //   data == "poly"
    //     ? environment.clientDetails.polyhex
    //     : environment.clientDetails.avahex;
    // 0x13881
    let chaninID = data == "poly" ? "0x13882" : "0xaa36a7";
    // alert(`${data} ${chaninID}  dadasda`)
    return new Promise(async (resolve, reject) => {
      try {
        // await window.ethereum.request({
        //   method: "wallet_addEthereumChain",
        //   params: [
        //     {
        //       chainId: chaninID,
        //       chainName: "Sepolia Testnet",
        //       nativeCurrency: {
        //         symbol: "ETH",
        //         decimals: 18,
        //       },
        //       rpcUrls: ["https://sepolia.infura.io"], // Replace with the RPC URL you use
        //       blockExplorerUrls: ["https://sepolia.etherscan.io"], // Sepolia block explorer
        //     },
        //   ],
        // });
        await window.ethereum
          .request({
            method: "wallet_switchEthereumChain",
            params: [{ chainId: chaninID }],
          })
          .then((data) => {

            console.log("Switch Ethereum Chain response:", data);
            this.getchainId().then((res) => {
              console.log("Current Chain ID:", res);
              resolve(data);
            });
          });
      } catch (e) {
        console.log(e, "error while changing network");
        resolve(data);
        this.toastr.error("Network Switch Rejected ");

        // console.error(e)
      }
    });
  }

  public getContract(contractType) {
    if (contractType == 'ERC20') {
      console.log("ERC20 contract ", this.erc20contract)
      console.log("ERC721 contract ", this.erc721contract)
      return this.erc20contract
    } else if (contractType == 'ERC20_Kombat') {
      return this.erc20_Kombatcontract
    } else if (contractType == 'ERC721') {
      return this.erc721contract
    } else if (contractType == 'MarketPlace') {
      return this.marketplacecontract
    } else if (contractType == 'ERC1155') {
      return this.erc1155contract
    } else if (contractType == 'MarketPlace_1155') {
      return this.marketplacecontract_1155
    } else if (contractType == 'LAZYMINT') {
      return this.lazymintcontract
    } else if (contractType == 'BATCHMINT') {
      return this.batchmintcontract
    } else if (contractType == 'BATCHMINT_MarketPlace') {
      return this.batchmintmarketplacecontract
    }
  }

  // public getContract(contractType, network) {
  //   var abi;
  //   var networkAddress;
  //   var contract_nw;
  //   if (network == 'rinkeby'){
  //     contract_nw = Contracts_Rinkeby
  //   }
  //   console.log("parameters in getcontract", contractType, network)
  //   return new Promise((resolve) => {
  //     const web3 = new Web3(this.provider)
  //     if (contractType === 'ERC721'){
  //       abi = SINGLE_NFT721_JSON;
  //       networkAddress = contract_nw.SINGLE_NFT721_ADDRESS;
  //     }else if(contractType == 'ERC1155'){
  //       abi = MULTIPLE_NFT1155_JSON;
  //       networkAddress = contract_nw.MULTIPLE_NFT1155_ADDRESS;
  //     }else if (contractType === 'MarketPlace'){
  //       abi = MARKET_PLACE_JSON;
  //       networkAddress = contract_nw.MARKET_PLACE_ADDRESS;
  //     }else if (contractType === 'ERC20'){
  //       abi = ERC_20_JSON;
  //       networkAddress = contract_nw.ERC_20_ADDRESS;
  //     }

  //     console.log("ABI is", abi);
  //     console.log("address is", networkAddress)
  //     const marketplace = new web3.eth.Contract(abi, networkAddress);

  //     resolve(marketplace);

  //   });
  // }

  // public getContract(contractType) {
  //   var abi;
  //   var networkAddress;
  //   var contract_nw;

  //   if (this.getNetwork() == 'Ethereum Rinkeby'){
  //     contract_nw = Contracts_Rinkeby
  //   }
  //   console.log("parameters in getcontract", contractType)

  //     const web3 = new Web3(this.provider)
  //     if (contractType === 'ERC721'){
  //       abi = SINGLE_NFT721_JSON;
  //       networkAddress = contract_nw.SINGLE_NFT721_ADDRESS;
  //     }else if(contractType == 'ERC1155'){
  //       abi = MULTIPLE_NFT1155_JSON;
  //       networkAddress = contract_nw.MULTIPLE_NFT1155_ADDRESS;
  //     }else if (contractType === 'MarketPlace'){
  //       abi = MARKET_PLACE_JSON;
  //       networkAddress = contract_nw.MARKET_PLACE_ADDRESS;
  //     }else if (contractType === 'ERC20'){
  //       abi = ERC_20_JSON;
  //       networkAddress = contract_nw.ERC_20_ADDRESS;
  //     }

  //     console.log("ABI is", abi);
  //     console.log("address is", networkAddress)
  //     const smartcontract = new web3.eth.Contract(abi, networkAddress);

  //     return smartcontract

  // }

  public async switchAccounts() {
    const walletAddress = await window.ethereum.request({
      method: "wallet_requestPermissions",
      params: [
        {
          eth_accounts: {},
        },
      ],
    });
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    return accounts[0];
    // return walletAddress
  }

  public convertPriceToEther(price) {
    // const web3 = new Web3();
    // return this.web3js.utils.toWei(price.toString(), 'Ether');
    return this.web3js.utils.toWei(price.toString(), "ether");
  }

  updateAccountAddress(account: any) {
    this.accountId.next(account);
  }

  public getAccount() {
    return this.accounts;
  }
  public getprovider() {
    return this.provider;
  }
  ngOnDestroy() {
    if (localStorage.getItem("WalletId") != undefined) {
      localStorage.removeItem("WalletId");
    }
    if (localStorage.getItem("networkId") != undefined) {
      localStorage.removeItem("networkId");
    }
  }

  ngAfterViewInit() {
    window.ethereum.on("accountsChanged", (accounts) => {
      //alert('account changed')
    });
  }
}